import { Link } from 'react-router-dom';
import { Building2, MapPin } from 'lucide-react';
import { cn } from '@/lib/utils';
import { AgencyTierBadge, type AgencyTier } from './AgencyTierBadge';

interface Props {
  id: string;
  name: string;
  logoUrl?: string | null;
  city?: string | null;
  saleCount: number;
  rentCount: number;
  highlighted?: boolean;
  tier?: AgencyTier;
}

export function TitaniumAgencyCard({ id, name, logoUrl, city, saleCount, rentCount, highlighted, tier }: Props) {
  const summary = saleCount && rentCount
    ? `${saleCount} for Sale · ${rentCount} for Rent`
    : saleCount ? `${saleCount} for Sale` : rentCount ? `${rentCount} for Rent` : 'No active listings';

  return (
    <Link
      to={`/agencies/${id}`}
      className={cn(
        'snap-start shrink-0 w-[320px] flex items-center gap-3 p-3 rounded-lg border bg-card hover:shadow-sm transition-all relative',
        highlighted && 'border-primary ring-1 ring-primary/40'
      )}
    >
      {tier && (
        <span className="absolute top-1.5 right-1.5">
          <AgencyTierBadge tier={tier} size="sm" />
        </span>
      )}
      <div className="h-[72px] w-[72px] shrink-0 rounded-md border bg-card flex items-center justify-center overflow-hidden">
        {logoUrl ? (
          <img src={logoUrl} alt={name} className="h-full w-full object-contain" />
        ) : (
          <Building2 className="h-7 w-7 text-muted-foreground" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-bold text-sm truncate">{name}</h3>
        <p className="text-xs text-muted-foreground mt-0.5 truncate">{summary}</p>
        {city && (
          <p className="flex items-center gap-1 text-xs text-primary mt-1">
            <MapPin className="h-3 w-3" /> {city}
          </p>
        )}
      </div>
    </Link>
  );
}
